import React from 'react';

import { ClassificationTable } from '..';
import thirdPartyConfig from './thirdPartyConfig';
import personnelConfig from './personnelConfig';
import { useHistory } from 'react-router-dom';
import { SpendTypeEnum, ITaxonomyItem, ITransactionItem, IRuleItem } from '..';
import { SPEND_LABELS } from '../ClassificationTable/utils';

const UPLOAD_URL = '/settings/data';
const RESTRIСTED_FIELDS = ['cost'];

interface IProps {
  spendType: SpendTypeEnum;
  taxonomyOptions: ITaxonomyItem[];
  lastUpdatedDate: string | null;
  updateTransactions(data: ITransactionItem[]): Promise<any>;
  updateRules(data: IRuleItem[]): Promise<any>;
  fetchSpendDataInfo(): Promise<any>;
  hasSalaryPermission: boolean;
  hasWritePermission: boolean;
}

export const ConfigTable: React.FC<IProps> = ({
  spendType,
  taxonomyOptions,
  lastUpdatedDate,
  hasSalaryPermission,
  updateTransactions,
  updateRules,
  fetchSpendDataInfo,
  hasWritePermission,
}) => {
  const history = useHistory();
  const configByType = {
    [SpendTypeEnum.THIRD_PARTY]: thirdPartyConfig,
    [SpendTypeEnum.PERSONNEL]: personnelConfig,
  };
  const handleBackClick = () => {
    history.push(UPLOAD_URL);
  };
  const config = {
    ...configByType[spendType],
    gridConfig: {
      columnDefs: configByType[spendType].gridConfig.columnDefs.filter(
        (column) =>
          !column.field ||
          !RESTRIСTED_FIELDS.includes(column.field) ||
          hasSalaryPermission
      ),
    },
  };

  return (
    <ClassificationTable
      {...config}
      hasWritePermission={hasWritePermission}
      spendType={spendType}
      label={SPEND_LABELS[spendType]}
      onBack={handleBackClick}
      timestamp={lastUpdatedDate}
      taxonomyOptions={taxonomyOptions}
      updateTransactions={updateTransactions}
      updateRules={updateRules}
      fetchSpendDataInfo={fetchSpendDataInfo}
    />
  );
};
